import styled, { css } from 'styled-components';

import { Radio } from 'antd';

const RadioGroup = styled(Radio.Group)`
  margin-bottom: 20px;

  .ant-radio-checked .ant-radio-inner {
    border-color: #00dace;
    &:after {
      background-color: #00dace;
    }
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #00dace;
  }
  ${props =>
    (props.mb || props.mb === 0) &&
    css`
      .ant-space-item {
        margin-bottom: ${props.mb}px !important;
      }
    `}
  ${props =>
    (props.mb_all || props.mb_all === 0) &&
    css`
      margin-bottom: ${props.mb_all}px !important;
    `}
    ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${props =>
    props.highlight === 'label' &&
    css`
      .ant-radio-wrapper-checked span {
        color: #00dace;
      }
    `}
  ${props =>
    props.type === 'cases' &&
    css`
      .ant-radio-button-wrapper {
        height: 50px;
        line-height: 45px;
        font-weight: 500;
        font-size: 16px;
        color: #3b2e0d;
        border: none;
        background-color: #f6f9fc;
        padding: 0 30px;

        &:before {
          display: none;
        }

        &.ant-radio-button-wrapper-checked,
        .ant-radio-group-solid
          .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
          background: #fff !important;
          color: #3b2e0d !important;
          box-shadow: 0 0 7px rgba(0, 0, 0, 0.15) !important;
          border-color: #fff !important;
          border-radius: 4px;
        }
        .ant-radio-group-solid
          .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
          box-shadow: 0 0 7px rgba(0, 0, 0, 0.15) !important;
        }
      }
    `}

  @media screen and (max-width: 900px) {
    .ant-radio-button-wrapper {
      font-size: 14px;
      padding: 0 10px;
    }
  }
`;

RadioGroup.defaultProps = {};

/** @component */
export default RadioGroup;
